// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-8d12bf60&scoped=true!./~/sass-loader?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OurTeam/CorporateSponsors.vue
// module id = 296
// module chunks = 2